import ExPanelSidebar from './ExPanelSidebar';

const ExPanel = () => (
  <div>
    <ExPanelSidebar />
  </div>
);

export default ExPanel;
